import React from 'react';
import {hot} from 'react-hot-loader';
import {getPageData} from '../../sources/CmsSource';
import {useGetPageData} from '../../actions/CmsActions';
import NewsContainer from './News.container';

const cmsUrlPattern = '/news';

const NewsView = () => {
    const pageData = useGetPageData({cmsUrlPattern});
    return <NewsContainer pageData={pageData || {}} />;
};

NewsView.getInitialProps = async (match, {locale}) => {
    const rawPageData = await getPageData(cmsUrlPattern);

    //must match structure of StoreProvider
    return {
        cms: {
            [cmsUrlPattern]: rawPageData
        }
    };
};

export default hot(module)(NewsView);
